const _excluded = ["leftIcon", "children", "boxProps", "dropdownIconProps", "paddingForLeftIcon"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
/**
 * sample usage:
 *

<Select>
  <option>one</option>
  <option>two</option>
  <option>three</option>
</Select>

or if you need padding, box needed as select comes with zero padding
<Box paddedRatio={1}>
  <Select>
    <option>one</option>
    <option>two</option>
    <option>three</option>
  </Select>
</Box>

or with overrides on icon
<Select dropdownIconProps={{fillColor: props.theme.textLight}}>
  <option>one</option>
  <option>two</option>
  <option>three</option>
</Select>
 */

import styled, { useTheme } from "styled-components";
import Box from "./Box";
import { GLYPHS, StyledIcon } from "./Icon";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const StyledSelect = styled.select.withConfig({
  displayName: "Select__StyledSelect",
  componentId: "sc-1lxi2hb-0"
})(["-moz-appearance:none;-webkit-appearance:none;min-height:34px;width:100%;border:none;border-radius:", ";padding-left:", ";padding-right:30px;color:", ";background:", ";& option{color:", ";}", " ", ""], p => p.theme.radiusSmall, p => p.paddingForLeftIcon || "10px", p => p.theme.textLight, p => p.theme.overlay, p => p.theme.textBlack, props => props.light && "\n    color: ".concat(props.theme.textBlack, ";\n    background: ").concat(props.theme.overlayInvert, ";\n  "), props => props.disabled && "opacity: 0.3;");
const ArrowPositioning = styled.div.withConfig({
  displayName: "Select__ArrowPositioning",
  componentId: "sc-1lxi2hb-1"
})(["", " right:10px;pointer-events:none;"], props => props.theme.verticalAlign("absolute"));
const LeftIconPositioning = styled.div.withConfig({
  displayName: "Select__LeftIconPositioning",
  componentId: "sc-1lxi2hb-2"
})(["", " pointer-events:none;"], props => props.theme.verticalAlign("absolute"));
const Select = props => {
  const {
      leftIcon,
      children,
      boxProps,
      dropdownIconProps,
      paddingForLeftIcon
    } = props,
    rest = _objectWithoutProperties(props, _excluded);
  const theme = useTheme();
  return /*#__PURE__*/_jsxs(Box, _objectSpread(_objectSpread({
    fullWidth: true
  }, boxProps), {}, {
    children: [leftIcon && /*#__PURE__*/_jsx(LeftIconPositioning, {
      children: leftIcon()
    }), /*#__PURE__*/_jsx(StyledSelect, _objectSpread(_objectSpread({
      leftIcon: leftIcon,
      paddingForLeftIcon: paddingForLeftIcon
    }, rest), {}, {
      children: children
    })), /*#__PURE__*/_jsx(ArrowPositioning, {
      children: /*#__PURE__*/_jsx(StyledIcon
      // light bg needs dark icon
      , _objectSpread({
        fillColor: props.light ? theme.textBlack : theme.textLight,
        styledWidth: "16px",
        glyph: GLYPHS.arrowDown
      }, dropdownIconProps))
    })]
  }));
};
export default Select;